import React, { useState , useRef } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { CommonServe } from "../services/api/CommonServ";
const Speaker = ({ open, onClose, onSave }) => {
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const fileInputRef = useRef('');
    const [viewUploader, setViewUploader] = useState(false);
  // Handle file upload and convert to base64 URL
 const handleImageUpload = async (e) => {
      const formData = new FormData();
  const file = e.target.files[0]; // This is the File object
  file.objectURL = URL.createObjectURL(file); // Optional: add objectURL for preview
//   console.log(file);
  formData.append("file", file);
    // console.log(file , e.target.files[0])
  if (file) {
    try {
const response = await CommonServe.uploadfiletos3(formData);   
// console.log(response);
 if (response && response.Location) {
        setImageUrl(response.Location);
      }
    } catch (error) {
      // Optionally show error to user
      console.error("Image upload failed:", error);
    }
  }
};

  const handleSave = () => {
    if (name && role) {
      onSave({ name, role, imageUrl });
      setName("");
      setRole("");
      setImageUrl("");
    }
  };

  const handleHide = () => {
    setName("");
    setRole("");
    setImageUrl("");
    onClose();
  };

  const handleUpload = (e) => {
    e.preventDefault();
    setViewUploader(true)
  }

 
  return (
    <Dialog header="Add Speaker" visible={open} style={{ width: "400px" }} onHide={handleHide}>
      <div className="p-fluid">
        <div className="field">
          <label htmlFor="speakerName">Name</label>
          <InputText id="speakerName" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="speakerRole">Role</label>
          <InputText id="speakerRole" value={role} onChange={(e) => setRole(e.target.value)} />
        </div>
              

                <div className="field">
          <label htmlFor="speakerImage">Image URL</label>
          <div style={{ display: "flex", alignItems: "center" }}>
            <InputText
              id="speakerImage"
              value={imageUrl}
              onChange={(e) => setImageUrl(e.target.value)}
              style={{ flex: 1 }}
            />
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              style={{ display: "none" }}
              id="upload-btn"
            ref={fileInputRef}
            />
            <label htmlFor="upload-btn" style={{ marginLeft: "8px" }}>
              <Button label="Upload" icon="pi pi-upload" className="p-button-sm"    onClick={() => fileInputRef.current && fileInputRef.current.click()} />
            </label>
          </div>
          {imageUrl && (
            <div style={{ marginTop: "8px" }}>
              <img src={imageUrl} alt="Speaker Preview" style={{ width: "80px", height: "80px", objectFit: "cover" }} />
            </div>
          )}
        </div>

        <div className="field">
          <Button label="Save" icon="pi pi-check" onClick={handleSave} />
        </div>
      </div>
    </Dialog>
  );
};
           

export default Speaker;